import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const EditPostDialog = ({ p, open, setOpen, onSaved }) => {
  const [text, setText] = useState(p.text || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.patch(`/posts/${p.id}`, { text, kind: "fact" }); onSaved(data); setOpen(false); toast.success("Fact updated. Middle is checking it again"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) setText(p.text || ""); setOpen(o); }}>
      <DialogContent className="max-w-xl" data-testid={`edit-post-dialog-${p.id}`}>
        <DialogHeader><DialogTitle>Edit fact</DialogTitle>
          <DialogDescription>Middle checks your fact again against approved sources after an edit. Readers will see it was edited.</DialogDescription></DialogHeader>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} maxLength={5000} data-testid="edit-post-text" />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" className="rounded-full" onClick={() => setOpen(false)} data-testid="edit-post-cancel">Cancel</Button>
          <Button className="rounded-full" disabled={busy || text.trim().length < 20} onClick={save} data-testid="edit-post-save">{busy ? "Saving…" : "Save changes"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
